import { render } from "./ModalEditCustomerReference.vue?vue&type=template&id=f6973b3a"
import script from "./ModalEditCustomerReference.vue?vue&type=script&lang=js"
export * from "./ModalEditCustomerReference.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__